import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Container } from './Container';
import { salesProof } from '../data/salesProof';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="bg-teal-light py-16 sm:py-20" data-id="element-203" data-mp="22369bvhw27tb">
      <Container data-id="element-204" data-mp="1x4browvnqpas">
        <div className="mx-auto grid max-w-4xl items-center gap-8 md:grid-cols-[auto_1fr] md:gap-12" data-id="element-205" data-mp="1x3to1f6o18su">
          <div className="mx-auto flex h-32 w-32 flex-col items-center justify-center rounded-full bg-white shadow-soft sm:h-40 sm:w-40" data-id="element-206" data-mp="19e7q0v214zmf">
            <ShieldCheckIcon aria-hidden="true" className="h-10 w-10 text-teal sm:h-12 sm:w-12" data-id="element-207" data-mp="14h8xggy0l0qc" />
            <span className="mt-1 font-heading text-3xl font-black leading-none text-navy sm:text-4xl" data-id="element-208" data-mp="1j6501yhaxljk">7</span>
            <span className="text-xs font-bold uppercase tracking-[0.14em] text-navy-soft" data-id="element-209" data-mp="1ecizh4oex844">días</span>
          </div>
          <div className="text-center md:text-left" data-id="element-210" data-mp="qlwslgq59tvp">
            <h2 id="guarantee-title" className="font-heading text-[2rem] font-black leading-[1.1] text-navy sm:text-4xl" data-id="element-211" data-mp="loddkelmhd2p">
              Garantía 7 días{salesProof.noQuestionsRefund && ' — sin preguntas'}
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-navy sm:text-xl" data-id="element-212" data-mp="twrwstgctuum">
              Abrís el material. Lo usás en tu semana.
              <br data-id="element-213" data-mp="12qwr5mup5oew" />
              Si en 7 días no es lo que esperabas: <strong className="font-extrabold" data-id="element-214" data-mp="12qepubt6gk04">devolución del 100%</strong>.
            </p>
            {salesProof.refundRate && <p className="mt-3 text-base font-semibold text-navy-soft" data-id="element-215" data-mp="azqoozri7emg">Tasa de devoluciones: menos del {salesProof.refundRate}.</p>}
            <p className="mt-3 text-sm text-navy-soft" data-id="element-216" data-mp="f0aokb3gowca">
              Según las{' '}
              <a href="#politica-reembolso" className="font-semibold text-navy underline decoration-navy/30 underline-offset-4 hover:decoration-navy" data-id="element-217" data-mp="k0ou9mhlbu75">
                condiciones de la garantía
              </a>
              .
            </p>
            <p className="mt-6 inline-flex rounded-full bg-pink px-4 py-2 font-display text-sm font-extrabold uppercase tracking-wide text-white" data-id="element-218" data-mp="1vdr31vdg7fgr">
              7 días de protección para tu compra
            </p>
          </div>
        </div>
      </Container>
    </section>;
}